import { createStorefrontApiClient } from '@shopify/storefront-api-client'
import fetch from 'isomorphic-fetch'

export const shopify = createStorefrontApiClient({
    storeDomain: process.env.GATSBY_SHOPIFY_STORE_URL,
    apiVersion: '2025-04',
    publicAccessToken: process.env.GATSBY_STOREFRONT_ACCESS_TOKEN,
    fetch,
})